export default __webpack_public_path__ + "static/media/cryptaroosbanner.53030c56.png";